import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Box,
  CircularProgress,
  Grid,
  Popover as MUIPopover,
} from '@mui/material';

//Popover component usinf Material UI Popover to show action to do count on page load
export default function Popover({
  count = null,
  open = false,
  anchorEl = null,
  handleClose = () => {},
  backgroundColor = 'wheat',
  isLoading = false,
}) {
  const { t } = useTranslation();

  return (
    <MUIPopover
      open={open}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      slotProps={{
        paper: {
          style: {
            backgroundColor: 'transparent',
            boxShadow: 'none',
            borderRadius: 0,
          },
        },
      }}
    >
      <Box
        sx={{
          position: 'relative',
          mt: '10px',
          '&::before': {
            backgroundColor: backgroundColor,
            content: '""',
            display: 'block',
            position: 'absolute',
            width: 12,
            height: 12,
            top: -6,
            transform: 'rotate(45deg)',
            left: 'calc(25% - 6px)',
          },
        }}
      />
      <Grid sx={{ p: 1, backgroundColor: backgroundColor, borderRadius: 2 }}>
        {!isLoading ? (
          count ? (
            t('action_to_do_message', { count: count })
          ) : (
            t('action_to_do_message', { count: 0 })
          )
        ) : (
          <CircularProgress />
        )}
      </Grid>
    </MUIPopover>
  );
}
